import type { FhVitalsResult } from '../sdk/fh-vitals-types'
import type { SubmitScanRequest } from './types'

/**
 * SubmitScanRequest requires sbp/dbp/hr (openapi.json); the SDK's "3 of 5 vitals present" usability
 * rule (fh-vitals-result.ts) does not guarantee those specific three are among the three. A frame
 * with spo2 + rr + only one of {sbp, dbp, hr} passes isUsableResult but cannot become a valid
 * submission, so this returns null for the caller to treat exactly like "no usable result" —
 * calibrated_sbp/calibrated_dbp are deliberately never read here; see D-7.
 */
export function toSubmitScanRequest(result: FhVitalsResult): SubmitScanRequest | null {
  const { sbp, dbp, hr, spo2, rr } = result
  if (!isPositive(sbp) || !isPositive(dbp) || !isPositive(hr)) {
    return null
  }
  return {
    sbp,
    dbp,
    hr,
    ...(isPositive(spo2) ? { spo2 } : {}),
    ...(isPositive(rr) ? { rr } : {}),
  }
}

function isPositive(value: number | null | undefined): value is number {
  return typeof value === 'number' && value > 0
}
